export const D7_TRIGGER_QA_SCENARIOS = [
  "birthday",
  "day1",
  "day2",
  "activity_completed",
  "hub_content_shared",
  "momentum",
  "opportunity_hot_takes",
  "opportunity_connect",
  "opportunity_deep_thoughts",
  "check_in",
  "opportunity_swap",
  "risk_of_pause",
  "empty",
  "end_of_day",
] as const;

export type D7TriggerQaScenario = (typeof D7_TRIGGER_QA_SCENARIOS)[number];

export function isD7TriggerQaScenario(
  value: string,
): value is D7TriggerQaScenario {
  return D7_TRIGGER_QA_SCENARIOS.some((scenario) => scenario === value);
}
